import React, { useState } from "react";
import { Box, IconButton, styled,Typography } from "@mui/material";
import { TrashBinMenuIconFilled } from "src/Icons/TrashBinMenuIconFilled";
import { generalStyles } from "src/utils/generalStyles/generalStyles";
import { getAvailableStudioTemplates } from "src/utils/helpers";
import { InfoString } from "src/utils/infoString";
import { isTitle } from "src/utils/validation";

import { DefaultInput } from "../Input/DefaultInput";

import { CustomRadioButton } from "./CustomRadioSelector";
import { NewDefaultNestedSelector } from "./NewDefaultNestedSelector";

const DeleteButton = styled(IconButton)({
  marginLeft: "8px",
  color: "#B9B9B9",
  "&:hover, &:active": {
    backgroundColor: "transparent",
  },
});

interface SkillSelectorProps {
    index: number;
    studioId: number;
    currentWorkplace: any;
    currentSkill:  {service: number, rank: string, specialty: string};
    existingServices: Array<any>;
    availableServices: any;
    onChange: (value: any) => void;
}

export const SkillSelector = ({
  index,
  studioId,
  currentWorkplace,
  currentSkill,
  existingServices,
  availableServices,
  onChange,
} : SkillSelectorProps) => {

  const [selectedService, setSelectedService] = useState(currentSkill?.service?.toString())
  const [selectedRank, setSelectedRank] = useState(currentSkill.rank)
  const [specialtyInput, setSpecialtyInput] = useState(currentSkill.specialty)

  const alreadyChosen = existingServices.map((value) => value?.service)

  const servicesWithoutChosen = getAvailableStudioTemplates(
    availableServices.templates,
    availableServices.ids.filter((id: number) => {
      if (id === +selectedService) {
        return true;
      } else {
        return !alreadyChosen.includes(id);
      }
    })
  );

  const handleChangeSelectService = (newValue: string) => {
    setSelectedService(newValue)
    const newWorkplace = JSON.parse(JSON.stringify(currentWorkplace));
    newWorkplace.skills[index] = {
      service: +newValue,
      rank: selectedRank,
      specialty: specialtyInput
    }
    onChange(newWorkplace);
  };

  const handleChangeSelectRank = (newValue: string) => {
    setSelectedRank(newValue)
    const newWorkplace = JSON.parse(JSON.stringify(currentWorkplace));
    newWorkplace.skills[index] = {
      service: +selectedService ? +selectedService : "",
      rank: newValue,
      specialty: specialtyInput
    }
    onChange(newWorkplace);
  };

  const handleChangeSpecialtyInput = (newValue: string) => {
    setSpecialtyInput(newValue)
    const newWorkplace = JSON.parse(JSON.stringify(currentWorkplace));
    newWorkplace.skills[index] = {
      service: +selectedService ? +selectedService : "",
      rank: selectedRank,
      specialty: newValue
    }
    onChange(newWorkplace);
  };

  const handleDeleteButton = () => {
    const newWorkplace = JSON.parse(JSON.stringify(currentWorkplace));
    newWorkplace.skills.splice(index, 1);
    onChange(newWorkplace);
  };

  return(
    <Box
      sx={{
        position: "relative",
      }}
    >
      <Box
        display="flex"
        flexDirection="row"
        justifyContent="space-between"
        alignItems="center"
        margin="28px 0 12px"
      >
        <Typography
          sx={{
            fontSize: "20px",
            fontWeight: "600",
          }}
        >
            Skill #{index + 1}
        </Typography>
        <InfoString child="Skill name is visible on the client side" />
      </Box>
      <DefaultInput
        initialValue={specialtyInput}
        label="Skill name"
        placeholder="skill name"
        target={studioId}
        onInputValueChange={handleChangeSpecialtyInput}
        validationFn={isTitle}
        sx={{
          ...generalStyles.borderRadiusAll,
          marginBottom: '24px',
        }}
      />
      <NewDefaultNestedSelector
        selectedValue={selectedService}
        valuesToSelectFrom={servicesWithoutChosen}
        onChanged={handleChangeSelectService}
        title="Service"
        leftContainerStyle={{
          height: "58px",
          minWidth: "192px",
          borderTopLeftRadius: "6px",
          borderBottomLeftRadius: "none",
          "& .MuiTypography-root": {
            fontSize: "16px",
          },
        }}
        rightContainerStyle={{
          height: "58px",
          borderTopRightRadius: "6px",
          borderBottomRightRadius: "none",
          "& .MuiOutlinedInput-root": {
            height: "58px",
          },
          "& .MuiInputBase-root.MuiOutlinedInput-root": {
            boxShadow: "none",
          },
          "& .MuiTypography-root": {
            fontSize: "16px",
          },
        }}
      />

      <CustomRadioButton
        value={selectedRank}
        label="Rank"
        onInputValueChange={handleChangeSelectRank}
        sx={{
          borderBottomLeftRadius: "6px",
          borderBottomRightRadius: "6px",
          marginBottom: "24px",
        }}
      />
      <DeleteButton
        onClick={() => handleDeleteButton()}
        disableRipple
        sx={{
          position: "absolute",
          top: "10px",
          right: "-45px",
        }}
      >
        <TrashBinMenuIconFilled />
      </DeleteButton>
    </Box>
  )
}
